import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  getChildObjects,
  getFormRoot,
} from '@intellio/shared/utils';
import type { FormlyHookFn } from './formly-hook-fn.type';

import * as _ from 'lodash';

export const generateCSEGProjectId = (): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const root = getFormRoot(field);

    const objs = getChildObjects(root, 'generateCSEGProjectId');

    const icProjectIdObj = _.find(
      objs,
      (obj) => obj.generateCSEGProjectId === 'ic_project_id'
    );

    const csegProjectIdObj = _.find(
      objs,
      (obj) => obj.generateCSEGProjectId === 'cseg_project_id'
    );
    if (!icProjectIdObj?.formControl || !csegProjectIdObj?.formControl) {
      return;
    }

    icProjectIdObj.formControl.valueChanges.subscribe((icProjectIdVal) => {
      if (typeof icProjectIdVal !== 'string' || !icProjectIdVal) {
        return;
      }

      const components = icProjectIdVal.split('-');

      components.splice(1, 0, 'CS');

      // Format: <opco>-CS-<number>
      if (icProjectIdVal) {
        csegProjectIdObj.formControl.setValue(
          components.join('-')
        );
      }
    });
  };
};
